import { LOOKUP_KEY_SOURCES, TRANSFORM_TYPES, VALUE_SPEC_KINDS, emptyTransformDraft, emptyValueSpecDraft } from '@/utils/mapperConfigDraft';
import MapperLiteralField from './MapperLiteralField.vue';
export default {
  name: 'MapperValueSpecForm',
  components: {
    MapperLiteralField
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    captures: {
      type: Array,
      required: false,
      default: () => []
    },
    lookupTables: {
      type: Array,
      required: false,
      default: () => []
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    dataTest: {
      type: String,
      required: false,
      default: 'mapper-value-spec'
    }
  },
  computed: {
    kinds() {
      return VALUE_SPEC_KINDS;
    },
    lookupKeySources() {
      return LOOKUP_KEY_SOURCES;
    },
    scaleSources() {
      return ['number', 'value'];
    },
    transformTypes() {
      return TRANSFORM_TYPES;
    },
    transformItems() {
      return TRANSFORM_TYPES.map(type => ({
        text: this.$i18n_t(`Bridges.mapperBuilder.transforms.${type}`),
        value: type
      }));
    }
  },
  methods: {
    setKind(kind) {
      if (!kind || kind === this.value.kind) {
        return;
      }
      this.value.kind = kind;
      if (kind === 'literal') {
        // The DSL has no transforms on plain literals, so drop them instead of writing
        // a config the bridge would reject.
        this.value.transforms = [];
      }
      if (kind === 'lookup' && this.value.lookup.source === 'from' && !this.value.lookup.from) {
        this.value.lookup.from = emptyValueSpecDraft('path');
      }
      this.$emit('change');
    },
    setField(field, next) {
      this.value[field] = next === null || next === undefined ? '' : next;
      this.$emit('change');
    },
    setLookupTable(next) {
      this.value.lookup.table = next === null || next === undefined ? '' : next;
      this.$emit('change');
    },
    setLookupSource(source) {
      if (!source) {
        return;
      }
      this.value.lookup.source = source;
      if (source === 'from' && !this.value.lookup.from) {
        this.value.lookup.from = emptyValueSpecDraft('path');
      }
      this.$emit('change');
    },
    addTransform(type) {
      const transform = emptyTransformDraft(type);
      if (type === 'scalePow10') {
        transform.spec = emptyValueSpecDraft('path');
      }
      this.value.transforms.push(transform);
      this.$emit('change');
    },
    setTransformType(transform, type) {
      transform.type = type;
      if (type === 'scalePow10' && !transform.spec) {
        transform.spec = emptyValueSpecDraft('path');
      }
      this.$emit('change');
    },
    setTransformAmount(transform, amount) {
      transform.amount = amount === null || amount === undefined ? '' : String(amount);
      this.$emit('change');
    },
    setScaleSource(transform, source) {
      if (!source) {
        return;
      }
      transform.scaleSource = source;
      if (source === 'value' && !transform.spec) {
        transform.spec = emptyValueSpecDraft('path');
      }
      this.$emit('change');
    },
    moveTransform(index, direction) {
      const target = index + direction;
      if (target < 0 || target >= this.value.transforms.length) {
        return;
      }
      const [transform] = this.value.transforms.splice(index, 1);
      this.value.transforms.splice(target, 0, transform);
      this.$emit('change');
    },
    removeTransform(index) {
      this.value.transforms.splice(index, 1);
      this.$emit('change');
    }
  }
};